<template>
  <div>
    <div class="lot-list">
      <LotList v-if="meetingId" :meetingId="meetingId" :outLotId='activeLotId' @changeLotId='listChangeLot'
               @getMeetingData='getMeetingData'></LotList>
    </div>
    <div class="lot-center">
      <div class="lot-conter-left">
        <LotContent ref="content" :meetingData='meetingData' :outData='lotData' :outLotId='activeLotId' @refresh-lot-data="getLotInfo"></LotContent>
      </div>
      <div class="lot-conter-right">
        <LotTalk v-if="activeLotId && meetingId " ref="lotTalk" :auctioneerData='auctioneerData'
                 :meetingData='meetingData' :meetingId="meetingId"
                 :outLotData='lotData' :outLotId='activeLotId'></LotTalk>
      </div>
    </div>
    <div class="lot-bottom-div">
      <el-row :gutter="24">
        <el-col :span="24">
          <LotInfo v-if="meetingData&&lotData" ref="lotInfo" :meetingData='meetingData' :outData='lotData'></LotInfo>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import LotList from '@/components/hall/LotList.vue';
import LotContent from '@/components/hall/LotContent.vue';
import LotTalk from '@/components/hall/LotTalk.vue';
import LotInfo from '@/components/hall/LotInfo.vue';
import {getDetail, updateViewCount} from '@/api/biz/auction/auctionLot';
import {getAuctioneerApi} from '@/api/biz/user/auctioneer';
import {mapGetters} from 'vuex';

export default {
  name: 'LotDetailView',
  components: {
    LotList,
    LotContent,
    LotTalk,
    LotInfo,
  },
  computed: {
    isLogin() {
      return this.userInfo.user_name;
    },
    userId() {
      return this.isLogin ? this.userInfo.user_id : parseInt(Math.random() * 999999);
    },
    userType() {
      if (this.isLogin) {//登录则为竞拍人、不登录为游客
        return 1;
      }
      return 4;
    },
    ...mapGetters(['userInfo']),
  },

  data() {
    return {
      activeLotId: null,
      lotData: {},
      meetingId: null,
      meetingData: {},
      auctioneerData: {},
      shouldReconnectWebsocket: true,
      websocketReconnecting: false,
    };
  },
  methods: {
    getAuctioneerInfo() {
      getAuctioneerApi(this.meetingData.auctioneerId).then(res => {
        this.auctioneerData = res.data.data;
      });
    },
    async initWebSocket() {
      return new Promise(resolve => {
        this.websocket = new WebSocket('wss://pm.qilua.com/websocket/auctionWebSocket');
        this.websocket.onopen = async (e) => {
          console.log('websocketOnOpen', e);
          this.heartbeatId = setInterval(() => {
            console.log('heartbeat');
            this.websocket.send(JSON.stringify({
              msgType: 0,
            }));
          }, 30000);
          if (this.websocketReconnecting) {
            this.websocketReconnecting = false;
            this.$message.success('网络连接已恢复');
            if (this.activeLotId) {
              await this.getLotInfo();
            }
          }
          resolve();
        };
        this.websocket.onmessage = this.websocketOnMessage;
        this.websocket.onerror = (e) => {
          console.error('websocketOnError', e);
        };
        this.websocket.onclose = (e) => {
          console.warn('websocketOnClose', e);
          if (this.heartbeatId) {
            clearInterval(this.heartbeatId);
            this.heartbeatId = null;
          }
          this.websocket = null;
          if (this.shouldReconnectWebsocket) {
            this.$message.error('网络连接出现异常，正在重连');
            console.warn('reconnectWebsocket in 5 seconds......');
            setTimeout(async (thiz) => {
              thiz.websocketReconnecting = true;
              await thiz.initWebSocket();
            }, 5000, this);
          }
        };
      });
    },
    websocketOnMessage(e) {
      let data = JSON.parse(e.data);
      console.log('websocketOnMessage', data);
      if (data.msgType) {
        if (data.msgType != 301) {//刷新标的信息
          this.getLotInfo();
        }
        if (data.msgType != 201) {//除了更新报价——刷新消息通知
          this.$refs.lotTalk.getMessageList();
        }
        if (data.msgType == 104 || data.msgType == 201 || data.msgType == 202) {//报价、结束、回退——刷新报价列表
          this.$refs.lotTalk.getPriceList();
          // 添加对 LotInfo 的竞价记录刷新
          if (this.$refs.lotInfo) {
            this.$refs.lotInfo.refreshPriceList();
          }
        }
      }
    },
    websocketSend() {
      if (!this.websocket || this.websocket.readyState !== WebSocket.OPEN) {
        console.error('websocket is not ready');
        return;
      }

      let obj = JSON.stringify({
        msgType: 11,
        data: JSON.stringify({
          userId: this.userId,
          userType: this.userType,
          lotId: this.activeLotId,
        }),
      });
      this.websocket.send(obj);
    },
    closeWebSocketManually() {
      console.warn('closeWebSocketManually', this.websocket);
      if (this.websocket && (this.websocket.readyState === WebSocket.OPEN || this.websocket.readyState === WebSocket.CONNECTING)) {
        this.shouldReconnectWebsocket = false;
        this.websocket.close();
      }
    },
    async listChangeLot(lotId) {
      this.activeLotId = lotId;
      await this.getLotInfo();
      this.$nextTick(() => {
        this.$refs.content.getApplyState();
        this.$refs.lotTalk.flushCurrentlotData();
        if (this.$refs.lotInfo) {
          this.$refs.lotInfo.refreshPriceList();
        }
      });
    },
    async getLotInfo() {
      const res = await getDetail(this.activeLotId);
      this.lotData = res.data.data;
      this.meetingId = this.lotData.meetingId;
      this.websocketSend();
      this.$nextTick(() => {
        this.$refs.content.queryInfoByLotId(this.activeLotId);
      });
      //更新围观次数
      updateViewCount({id: this.activeLotId});
    },
    getMeetingData(data) {
      this.meetingData = data;
      this.getAuctioneerInfo();
    },
  },
  async mounted() {
    await this.initWebSocket();
    this.activeLotId = this.$route.query.lotId;
    if (this.$route.query.meetingData) {
      this.meetingData = JSON.parse(this.$route.query.meetingData);
      this.meetingId = this.meetingData.id;
    } else {
      this.meetingId = this.$route.query.meetingId;
    }
    if (this.activeLotId) {
      await this.getLotInfo();
    }
    window.addEventListener('beforeunload', this.closeWebSocketManually);
  },
  async unmounted() {
    this.closeWebSocketManually();
    window.removeEventListener('beforeunload', this.closeWebSocketManually);
  },
};
</script>

<style scoped>
.lot-bottom-div {
  margin-top: 20px;
}

.lot-conter-right {
  display: inline-block;
  width: 299px;
  height: 440px;
  vertical-align: bottom;
  border-left: 1px solid rgba(215, 215, 215, 1);
}

.lot-conter-left {
  display: inline-block;
  width: 1000px;
  height: 440px;
  vertical-align: bottom;
}

.lot-info-div {
  min-height: 700px;
}

.lot-center {
  display: flex;
  margin-top: 20px;
  width: 1300px;
  height: 442px;
  opacity: 1;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
}

.lot-list {
  width: 1300px;
  height: 270px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
}
</style>
